import { engineComponent, StringUtils, Utils } from "neo-common";
import { ComponentTypes } from "../../Components/ComponentTypes";
import { HtmlContainerElement } from "../Elements/HtmlContainerElement";
import { BetManager } from "../../Managers/BetManager";
import { AppContext } from "../../../Common/AppContext";
import { HtmlController } from "../HtmlController";
import { BaseActions } from "../../Channels/Common/Actions/BaseActions";
import { Languages } from "../../Utils/Languages";

@engineComponent(ComponentTypes.HtmlElement)
export class HtmlBetSelectorContainerElement2 extends HtmlContainerElement {
    private _popup: HTMLDivElement;
    private _values: Array<HTMLDivElement>;
    private _height: string;

    protected block: boolean;
    protected timeout: number;

    constructor() {
        super();

        BetManager.BetContainer = this;
    }

    create(node: Element): void {
        super.create(node);

        this._popup = <HTMLDivElement>document.createElement("div");
        this._popup.classList.add("display");
        this._popup.classList.add("popupBig");

        if (this.instance != null) {
            this.instance.appendChild(this._popup);
        }

        this.block = true;
        this.createTimeout();
    }

    addValues(): void {
        if (!AppContext.gameConfiguration.UseCoins && BetManager.TotalBets != null && this._popup != null) {
            this._values = [];
            this._popup.innerHTML = "";
            let count: number = 0;
            for (let i: number = BetManager.TotalBets.length - 1; i >= 0; i--) {
                let popupItem: HTMLDivElement = <HTMLDivElement>document.createElement("div");
                popupItem.classList.add("popupItem");
                popupItem.onclick = this.onValueClick.bind(this);
                popupItem.setAttribute("Bet", BetManager.TotalBets[i].toString());
                if (BetManager.Bet != null && BetManager.Bet == BetManager.TotalBets[i]) {
                    popupItem.classList.add("_active");
                }
                let popupItemValue: HTMLDivElement = <HTMLDivElement>document.createElement("div");
                popupItemValue.classList.add("popupValue");

                popupItemValue.innerText = Languages.formatText(
                    Languages.FormatMoney,
                    BetManager.TotalBets[i].toString(),
                );

                popupItem.appendChild(popupItemValue);
                this._values.push(popupItem);
                this._popup.appendChild(popupItem);
                count++;
            }

            this._height = 60 * count + 48 + "px";
        }
    }

    private onValueClick(e: any): void {
        if (this.block) {
            return;
        }

        this.setTimeout();
        if (e != null && e.currentTarget != null && e.currentTarget.hasAttribute("Bet") && BetManager.Bet != null) {
            let bet: number = parseFloat(e.currentTarget.getAttribute("Bet"));
            if (bet === BetManager.Bet) {
                this.disable();
            } else {
                if (this._values != null) {
                    for (let i: number = 0; i < this._values.length; i++) {
                        if (this._values[i].hasAttribute("Bet")) {
                            if (parseFloat(this._values[i].getAttribute("Bet")) === bet) {
                                this._values[i].classList.add("_active");
                            } else {
                                this._values[i].classList.remove("_active");
                            }
                        }
                    }
                    HtmlController.dispatchAction(BaseActions.ActionBetSelectValue + bet);
                    this.disable();
                }
            }
        }
    }

    changeValue(): void {
        if (this._values != null) {
            for (let i: number = 0; i < this._values.length; i++) {
                if (this._values[i].hasAttribute("Bet")) {
                    if (parseFloat(this._values[i].getAttribute("Bet")) === BetManager.Bet) {
                        this._values[i].classList.add("_active");
                    } else {
                        this._values[i].classList.remove("_active");
                    }
                }
            }
        }
    }

    toggle(): void {
        if (this._values != null && this._values.length <= 1) {
            return;
        }

        if (this.instance != null) {
            if (this.instance.classList.contains("_disabled")) {
                this.block = false;
                this.setTimeout();
                if (this._height != null) {
                    this.instance.style.height = this._height;
                }
                this.instance.classList.remove("_disabled");
            } else {
                this.block = true;
                this.clearTimeOut();
                this.instance.removeAttribute("style");
                this.instance.classList.add("_disabled");
            }
        }
    }

    disable(): void {
        if (this.instance != null) {
            if (!this.instance.classList.contains("_disabled")) {
                this.block = true;
                this.clearTimeOut();
                this.instance.removeAttribute("style");
                this.instance.classList.add("_disabled");
            }
        }
    }

    protected createTimeout(): void {
        this.timeout = null;
    }

    protected setTimeout(): void {
        this.clearTimeOut();

        const duration = AppContext.gameConfiguration.SelectorRolloutDuration;

        if (duration > 0) {
            this.timeout = setTimeout((): void => {
                this.disable();
            }, duration * 1000);
        }
    }

    protected clearTimeOut(): void {
        if (!Utils.isNullOrUndefined(this.timeout)) {
            clearTimeout(this.timeout);

            this.timeout = null;
        }
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/HTMLComponents/Custom/HtmlBetSelectorContainerElement2.ts
 **/